import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { ResultStatus } from '../../../../core/picks/pick-models';
import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { stringToNullableNumber } from '../error-convert-helpers';
import { ResultError } from './result-error';

export class PickStatusChanged extends ResultError {
    constructor(pickId: string, optionStatus: string | undefined) {
        super(pickId);
        const status = stringToNullableNumber(optionStatus);
        this.status = status === null ? ResultStatus.Unknown : (status as ResultStatus);
        this.icon = BetPlacementErrorIcon.Warning;
        this.type = PlacementErrorType.ChangedOptionStatus;
    }

    status: ResultStatus;
}
